var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3834_78377)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5298 9.62313C11.2097 9.86858 10.9987 10.2473 10.9965 10.6507L10.9929 11.3135C11.0378 11.8908 10.5 12.1876 10.0009 11.7961L9.13861 11.2676C8.72518 11.0142 8.23447 10.9287 7.75123 10.969C7.50514 10.9894 7.25442 11 7 11C3.68629 11 1 9.20914 1 7C1 4.79086 3.68629 3 7 3C10.3137 3 13 4.79086 13 7C13 8.0036 12.4456 8.92087 11.5298 9.62313ZM7 8C7.55228 8 8 7.55228 8 7C8 6.44772 7.55228 6 7 6C6.44772 6 6 6.44772 6 7C6 7.55228 6.44772 8 7 8ZM11 7C11 7.55228 10.5523 8 10 8C9.44771 8 9 7.55228 9 7C9 6.44772 9.44771 6 10 6C10.5523 6 11 6.44772 11 7ZM4 8C4.55228 8 5 7.55228 5 7C5 6.44772 4.55228 6 4 6C3.44772 6 3 6.44772 3 7C3 7.55228 3.44772 8 4 8Z",
    fill: "#F2A918"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3834_78377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentNotifications);
export default __webpack_public_path__ + "static/media/CommentNotifications.f67da866168bf58b5a6bd5c5732a7e7a.svg";
export { ForwardRef as ReactComponent };